import { useState } from "react";
import { CommonUserTaskNew } from "../CommonUserTaskNew";
import { infoConfig } from "./infoConfig";
import { formConfig } from "./formConfig";
import { validateDecision } from "./validation";
import { InsuranceOptions, type CommonData } from "../../../types/common";
import {
  formatAccountNumber,
  getAccountNumber,
} from "../../../utils/account.helper";
import { getRolesFromSessionStorage, isReaderOnly } from "../../../utils/userHelper";

const ManualCheckFinalSe = (props: any) => {
  const data: CommonData = props.flow?.data;
  const applicant = data?.agentApiApplication?.applicant;
  const coapplicant = data?.agentApiApplication?.coapplicant;
  const status = props.flow?.caseData?.status;
   const userRoles = getRolesFromSessionStorage();
  const userIsReader = isReaderOnly(userRoles);
  const autogiroAccountNumberInitialValue =
    props.task?.data.autogiroAccountNumber ??
    formatAccountNumber(getAccountNumber(props, "autogiro"), true, data?.country) ??
    undefined;
  const disbursementAccountNumberInitialValue =
    props.task?.data.disbursementAccountNumber ??
    formatAccountNumber(getAccountNumber(props, "disbursement"), false, data?.country) ??
    undefined;

  const [checklistValues, setChecklistValues] = useState(
    props.task?.data.checklistValues ?? [],
  );
  const [decision, setDecision] = useState(props.task?.data.decision ?? null);
  const [comment, setComment] = useState(props.task?.data.comment ?? null);

  // If a previous insurance sale value exists in task data, use that.
  // Otherwise, fall back to context value set during task creation. If all other fails default to "without_insurance".
  const [insuranceSale, setInsuranceSale] = useState(
    props.task?.data.insuranceSale ??
      props.task?.context?.insuranceSelectedLabel ??
      InsuranceOptions.WITHOUT_INSURANCE,
  );
  const [autogiroAccountNumber, setAutogiroAccountNumber] = useState<
    string | undefined
  >(autogiroAccountNumberInitialValue);

  const [disbursementAccountNumber, setDisbursementAccountNumber] = useState<
    string | undefined
  >(disbursementAccountNumberInitialValue);

  const [errorMessages, setErrorMessages] = useState<string | null>(null);

  const handleDecisionChange = (value: any) => {
    const decisionValue = value === "true";
    setDecision(decisionValue);
  };

  const handleInsuranceSaleChange = (value: any) => {
    setInsuranceSale(value);
  };

  const handleNoteChange = (value: any) => {
    setComment(value);
  };

  const handleAutogiroAccountNumberChange = (value: any) => {
    setAutogiroAccountNumber(value);
  };

  const handleDisbursementAccountNumberChange = (value: any) => {
    setDisbursementAccountNumber(value);
  };

  const handleSave = async () => {
    const formData = {
      checklistValues,
      decision,
      insuranceSale,
      autogiroAccountNumber,
      disbursementAccountNumber,
      comment,
    };
    props.save(formData, (error: any) => console.error({ error }), true);
  };

  const handleComplete = async (): Promise<void> => {
    if (decision === null) {
      setErrorMessages("Please select a decision.");
      return;
    }
    const checklist = checklistValues.map((value: string) => {
      return {
        text: value,
        checked: true,
      };
    });

    const formData = {
      checklist,
      decision,
      insuranceSale,
      autogiroAccountNumber: autogiroAccountNumber ?? null,
      disbursementAccountNumber: disbursementAccountNumber ?? null,
      comment: comment ?? "",
    };

    props.complete(
      formData,
      () => {},
      (e: any) => {
        setErrorMessages(e?.detail);
      },
    );
  };

  return (
    <CommonUserTaskNew
      handleComplete={handleComplete}
      handleSave={handleSave}
      infoConfig={infoConfig({ checklistValues, setChecklistValues })}
      formConfig={formConfig({
        errorMessages,
        applicant,
        coapplicant,
        decision,
        insuranceSale,
        autogiroAccountNumber,
        disbursementAccountNumber,
        handleAutogiroAccountNumberChange,
        handleDisbursementAccountNumberChange,
        handleDecisionChange,
        handleNoteChange,
        handleInsuranceSaleChange,
        comment,
        data,
        status,
      })}
      overrideMasonryColumns={1}
      disablePrimary={userIsReader}
      disableSecondary={userIsReader}
    />
  );
};

export default ManualCheckFinalSe;